import styled from '@emotion/styled';

export const ProductsContainerStyled = styled.div`
  min-height: calc(-392px + 100vh);
`;
